import { createReducer } from 'redux-act';

import {
  CONFIGS_FETCH_DATA_INIT, CONFIGS_FETCH_DATA_SUCCESS, CONFIGS_FETCH_DATA_FAIL,
  CONFIGS_DELETE_CONFIG_INIT, CONFIGS_DELETE_CONFIG_SUCCESS, CONFIGS_DELETE_CONFIG_FAIL,
  CONFIGS_CREATE_CONFIG_INIT, CONFIGS_CREATE_CONFIG_SUCCESS, CONFIGS_CREATE_CONFIG_FAIL,
  CONFIGS_MODIFY_CONFIG_INIT, CONFIGS_MODIFY_CONFIG_SUCCESS, CONFIGS_MODIFY_CONFIG_FAIL,
  CONFIGS_CLEAN_UP, CONFIGS_CLEAR_DATA_LOGOUT,
  SET_CONFIG_TAB, SET_ACTIVE_CONFIG,
} from 'state/actions/configuration';

const initialState = {
  list: [],
  config: {
    colors: [],
    medias: [],
    siteId: '',
    modifiedAt: '',
    modifiedBy: '',
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
  tab: 'configSettings',
  activeConfig: {
    _id: '',
    name: '',
    description: '',
  },
};

export const configurationReducer = createReducer(
  {
    [CONFIGS_FETCH_DATA_INIT]: (state) => ({
      ...state, loading: true, error: null, success: false,
    }),
    [CONFIGS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state, config: payload.config, loading: false, error: null,
    }),
    [CONFIGS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state, loading: false, error: payload.error,
    }),
    [CONFIGS_CREATE_CONFIG_INIT]: (state) => ({
      ...state, loading: true, success: false,
    }),
    [CONFIGS_CREATE_CONFIG_SUCCESS]: (state, payload) => ({
      ...state, list: [...state.list, payload.config], loading: false, success: true,
    }),
    [CONFIGS_CREATE_CONFIG_FAIL]: (state, payload) => ({
      ...state, loading: false, error: payload.error, success: false,
    }),
    [CONFIGS_MODIFY_CONFIG_INIT]: (state) => ({
      ...state, loading: true, updated: false,
    }),
    [CONFIGS_MODIFY_CONFIG_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) =>
        item._id === payload.config._id ? payload.config : item
      ),
      loading: false, updated: true,
    }),
    [CONFIGS_MODIFY_CONFIG_FAIL]: (state, payload) => ({
      ...state, loading: false, error: payload.error, updated: false,
    }),
    [CONFIGS_DELETE_CONFIG_INIT]: (state) => ({
      ...state, loading: true, deleted: false,
    }),
    [CONFIGS_DELETE_CONFIG_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false, deleted: true,
    }),
    [CONFIGS_DELETE_CONFIG_FAIL]: (state, payload) => ({
      ...state, loading: false, error: payload.error, deleted: false,
    }),
    [CONFIGS_CLEAN_UP]: (state) => ({
      ...state, loading: false, error: null, success: false, deleted: false, updated: false,
    }),
    [CONFIGS_CLEAR_DATA_LOGOUT]: () => ({ ...initialState }),
    [SET_CONFIG_TAB]: (state, payload) => ({
      ...state, tab: payload,
    }),
    [SET_ACTIVE_CONFIG]: (state, payload) => ({
      ...state, activeConfig: payload,
    }),
  },
  initialState
);
